<template>
  <div class="concept-attributes-display">
    <AttributeDisplay v-for="(attribut, index) in sortedAttributes" :key="index" :uri="attribut.uri"
      :title="attribut.title" :label="attribut.label" :values="attribut.values"
      :multilingualValues="attribut.multilingualValues" :accordion="attribut.accordion"
      :accordiontDisplayOpen="attribut.accordiontDisplayOpen" :display="attribut.display" :order="attribut.order"
      :litterals="attribut.litterals" :blankNodes="attribut.blankNodes" :axiomAnnotations="attribut.axiomAnnotations"
      :negative="attribut.negative" :level0="true" />
  </div>
</template>

<script>
import AttributeDisplay from "./AttributeDisplay";

export default {
  name: "AttributesDisplay",

  components: {
    AttributeDisplay
  },
  props: {
    attributesFormatted: Array,
  },

  computed: {
    sortedAttributes() {
      return [...this.attributesFormatted].sort((a, b) => {
        const orderA = a.order !== undefined ? a.order : Infinity;
        const orderB = b.order !== undefined ? b.order : Infinity;
        return orderA - orderB;
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.concept-attributes-display {
  color: #697097;
  display: flex;
  flex-direction: column;
}
</style>